import { createFileRoute } from '@tanstack/react-router'
import { SettingsContent, useSettingTitle } from '~/templates/settings'

import { OrganizationAvatarForm } from './-components/avatar-form'
import { OrganizationDomainAccessForm } from './-components/domain-access-form'
import { OrganizationInfoForm } from './-components/info-form'
import { OrganizationProfilePreview } from './-components/profile-preview'

export const Route = createFileRoute('/_authenticated/$alias/settings/organization/')({
  component: RouteComponent,
})
function RouteComponent() {
  useSettingTitle(['Organization'])
  return (
    <SettingsContent>
      <OrganizationAvatarForm />
      <OrganizationInfoForm />
      <OrganizationProfilePreview />
      <OrganizationDomainAccessForm />
    </SettingsContent>
  )
}
